import { Button, Space } from "antd";
import React from "react";
import i18n from "../../../i18n";

const FilterDropdownButtons = ({ confirm }) => (
  <Space>
    <Button type="primary" onClick={() => confirm()} size="small" style={{ minWidth: 80 }}>
      {i18n.t("container.general_words.apply")}
    </Button>
    <Button
      style={{ minWidth: 80 }}
      size="small"
      type="secondary"
      onClick={() => {
        confirm({ closeDropdown: false });
      }}
    >
      {i18n.t("container.general_words.preview")}
    </Button>
  </Space>
);

export default FilterDropdownButtons;
